import React from "react";

export default function Loading() {
  return (
    <div className="loading‑overlay">
      <div className="spinner‑ring" />
    </div>
  );
}

